module.exports = __webpack_public_path__ + "img/shibuya.a629428a.svg";